import type { CatalogResponse, GenerationModel, GenerationMode } from '@/types/api'

export const fallbackCatalog: CatalogResponse = {
  aspect_ratios: ['9:16', '1:1', '16:9'],
  max_image_outputs: 1,
  models: [
    {
      id: 'recraft_pro',
      label: '🔥 UIG 1.0',
      description: 'High-end lifestyle and vector photography.',
      mode: 'text_to_image',
      durations: [],
      supports_audio: false,
      fixed_cost: 8,
    },
    {
      id: 'seedream_v5_pro_t2i',
      label: '🔥 UIG 1.2',
      description: 'Photorealistic images with precise prompt following.',
      mode: 'text_to_image',
      durations: [],
      supports_audio: false,
      fixed_cost: 10,
    },
    {
      id: 'seedream_v5_pro',
      label: '🔥 UIG 1.2',
      description: 'Transform materials and backgrounds seamlessly.',
      mode: 'image_to_image',
      durations: [],
      supports_audio: false,
      fixed_cost: 10,
    },
    {
      id: 'wan3_t2v',
      label: '🔥 UIG 2.3',
      description: 'High-quality realistic video generation.',
      mode: 'text_to_video',
      durations: [5, 10, 15, 20, 30],
      supports_audio: true,
      credits_per_second: 24,
    },
    {
      id: 'skyreels_v4',
      label: '🔥 UIG 2.5',
      description: 'Cinematic video generation with rich lighting.',
      mode: 'text_to_video',
      durations: [5, 10, 15],
      supports_audio: true,
      credits_per_second: 28,
    },
    {
      id: 'seedance_2',
      label: '🔥 UIG 3.0 Pro',
      description: 'Top-tier realistic image to video animation.',
      mode: 'image_to_video',
      durations: [5, 10, 15],
      supports_audio: false,
      credits_per_second: 48,
    },
    {
      id: 'wan3_i2v',
      label: '🔥 UIG 2.3',
      description: 'Smooth image animation and cinematic motion.',
      mode: 'image_to_video',
      durations: [5, 10, 15, 20, 30],
      supports_audio: true,
      credits_per_second: 24,
    },
  ],
}

export function modelsForMode(catalog: CatalogResponse, mode: GenerationMode): GenerationModel[] {
  return catalog.models.filter((model) => model.mode === mode)
    .sort((a, b) => a.label.localeCompare(b.label, 'en', { numeric: true }))
}

export function modelCost(model: GenerationModel, duration: number, outputCount: number): number {
  const unitCost = model.fixed_cost ?? (model.credits_per_second ?? 0) * duration
  return unitCost * outputCount
}
